var r=function(r){return"url(#"+r+")"};export{r as getUrlAttribute};
